// extracted by mini-css-extract-plugin
module.exports = {"searchSection":"JobReport_searchSection__seqw3","buttons":"JobReport_buttons__2kOps","jobSeciton":"JobReport_jobSeciton__3R2IC","subTitle":"JobReport_subTitle__1Mh1G"};